/**
 * The visitor's country by IP, as a lowercase ISO code, or '' when unknown.
 *
 * Asked from the site's own /_sys/forms/geo-country (GeoCountry): Cloudflare's
 * CF-IPCountry header on a proxied site, else a local DB-IP database — the IP is
 * never sent to a third party. Kept for the session: one request per visitor.
 *
 * Read in the browser, not written into the HTML by PHP: with page caching the
 * first visitor's country would be served to everyone after them.
 */
const GEO_KEY = 'exoPhoneGeoCountry'
let geo = null

function geoCountry() {
    if (geo) return geo
    let cached = null
    try { cached = sessionStorage.getItem(GEO_KEY) } catch (e) { /* storage blocked */ }
    if (cached !== null) return (geo = Promise.resolve(cached))

    geo = fetch('/_sys/forms/geo-country', { credentials: 'same-origin' })
        .then(r => (r.ok ? r.json() : {}))
        .then(json => (/^[a-z]{2}$/.test(json.country || '') ? json.country : ''))
        .catch(() => '')
        .then(code => {
            try { sessionStorage.setItem(GEO_KEY, code) } catch (e) { /* storage blocked */ }
            return code
        })
    return geo
}

export default geoCountry
